// Do not import { store } from "@root/store" here. This reducer is loaded while
// store/index.js is still creating the store; that import caused a TDZ crash in prod
// ("Cannot access 'b' before initialization"). getStore() is filled after createStore.
import { getStore } from "./storeRef";
// Isolated helper — not getAxiosConfig — so this file does not pull axios/store
// back into the reducer graph at import time.
import { getUserAgent } from "../src/utils/getUserAgent";

// DEFAULT APP ACCENT COLOR
export const DEFAULT_APP_ACCENT_COLOR = `009AE0`;

// ACTION TYPES
export const ACTION_TYPES = {
  SET_PERSISTED_DATA: `SET_PERSISTED_DATA`,
  SET_USER_TOKEN: `SET_USER_TOKEN`,
  SET_USER_DETAILS_DATA: `SET_USER_DETAILS_DATA`,
  SET_ORG_DETAILS_DATA: `SET_ORG_DETAILS_DATA`,
  SET_DEVICE_TYPE: `SET_DEVICE_TYPE`,
};

// FUNCTION TO SET APP TOKEN AND COLOR
export const setAppConfig = () => {
  // alert("setAppConfig");
  const userToken =
    new URLSearchParams(window?.location?.search).get("token") || "";
  const isAPKFlag =
    new URLSearchParams(window?.location?.search).get("is_apk") || 0;
  const appAccent =
    new URLSearchParams(window?.location?.search).get("color") ||
    DEFAULT_APP_ACCENT_COLOR;
  const region =
    new URLSearchParams(window?.location?.search).get("region") || "IN";
  const defaultLanguage = new URLSearchParams(window?.location?.search).get(
    "defaultLanguage"
  );
  const isNewPaymentFlow =
    new URLSearchParams(window?.location?.search).get("isNewPaymentFlow") || 0;
  const isGbpsFlow =
    new URLSearchParams(window?.location?.search).get("isGbpsFlow") || 0;
  const countryCode =
    new URLSearchParams(window?.location?.search).get("country") || "in";
  let userAgent = getUserAgent();

  // console.log("V___________3 search: ", window?.location?.search);
  // console.log("V___________4 searchToken: ", userToken);

  // SETTING USER TOKEN AND APP ACCENT COLOR IN LOCAL STORAGE
  // userToken && localStorage.clear();
  userToken && localStorage.setItem("userToken", userToken);
  appAccent && localStorage.setItem("appAccent", appAccent);
  region && localStorage.setItem("region", region);
  defaultLanguage && localStorage.setItem("defaultLanguage", defaultLanguage);
  localStorage.setItem("userAgent", userAgent);
  localStorage.setItem("isNewPaymentFlow", isNewPaymentFlow);
  localStorage.setItem("isGbpsFlow", isGbpsFlow);
  localStorage.setItem("isAPKFlag", isAPKFlag);
  localStorage.setItem("isOutsideIndia", countryCode.toLowerCase() === "in" ? 0: 1);
  // DISPATCHING SET APP CONFIG ACTION IF URL HAS TOKEN OR COLOR
  if (userToken) {
    // Runtime lookup; ?. if somehow called before setStore (should not happen after boot)
    getStore()?.dispatch(
      setPersistedDataAction({
        userToken: userToken,
        appAccent: appAccent,
        region: region,
        deviceType: userAgent,
        defaultLanguage: defaultLanguage,
        isNewPaymentFlow: isNewPaymentFlow,
        isGbpsFlow: isGbpsFlow,
      })
    );
  }
};

// FUNCTION TO SET APP TOKEN
export const setAppToken = (userToken) => {
  localStorage.setItem("userToken", userToken);
  getStore()?.dispatch(setUserTokenAction(userToken));
};

// ACTIONS
export const setPersistedDataAction = (payload) => {
  // console.log("V___________3.5 actionPayload: ", payload);
  return {
    type: ACTION_TYPES.SET_PERSISTED_DATA,
    payload,
  };
};
export const setUserTokenAction = (payload) => {
  return {
    type: ACTION_TYPES.SET_USER_TOKEN,
    payload,
  };
};

// INITIAL STATE
const persistedDataInitialState = {
  userToken: "",
  appAccent: `${DEFAULT_APP_ACCENT_COLOR}`,
  region: "",
  deviceType: "",
  orgDetails: undefined,
};

// STATE ALTERING FUNCTIONS
const setAppConfigReducer = ({
  userToken,
  appAccent,
  region,
  deviceType,
  defaultLanguage,
  isNewPaymentFlow,
}) => {
  return {
    userToken: userToken,
    appAccent: appAccent || DEFAULT_APP_ACCENT_COLOR,
    region: region,
    deviceType: deviceType,
    defaultLanguage: defaultLanguage,
    isNewPaymentFlow: isNewPaymentFlow,
  };
};
const setUserToken = (userToken) => {
  return {
    userToken: userToken,
  };
};
const setUserDetailsReducerFn = (payload) => {
  localStorage.setItem("userDetails", JSON.stringify(payload));
  return {
    userDetails: payload,
  };
};
const setOrgDetailsReducerFn = (payload) => {
  localStorage.setItem("orgDetails", JSON.stringify(payload));
  return {
    orgDetails: payload,
  };
};
const setDeviceTypeReducerFn = (payload) => {
  localStorage.setItem("deviceType", payload);
  return {
    deviceType: payload,
  };
};

// REDUCER
const persistedDataReducer = (state = persistedDataInitialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_PERSISTED_DATA: {
      return { ...state, ...setAppConfigReducer(action?.payload) };
    }
    case ACTION_TYPES.SET_USER_TOKEN: {
      return { ...state, ...setUserToken(action?.payload) };
    }
    case ACTION_TYPES.SET_USER_DETAILS_DATA: {
      return { ...state, ...setUserDetailsReducerFn(action?.payload) };
    }
    case ACTION_TYPES.SET_ORG_DETAILS_DATA: {
      return { ...state, ...setOrgDetailsReducerFn(action?.payload) };
    }
    case ACTION_TYPES.SET_DEVICE_TYPE: {
      return { ...state, ...setDeviceTypeReducerFn(action?.payload) };
    }
    default:
      return state;
  }
};

export default persistedDataReducer;
